import React from "react";
import classNames from "classnames";
import { PhosphorCheck, PhosphorX } from "./PhosphorIcon";

interface ToggleProps {
  variant: "circle" | "icons"
  value: boolean
  onChange: (value: boolean) => void
}

export const Toggle = (props: ToggleProps) => {
  const handleClick = () => {
    props.onChange(!props.value);
  };

  const [pressing, setPressing] = React.useState(false);

  const squishX = pressing ? 1.15 : 1;
  const squishY = pressing ? 0.92 : 1;

  const left = props.value ? 25 : 2;

  return (
    <button
      type="button"
      className="toggle-button-wrapper"
      role="switch"
      aria-checked={props.value}
      onClick={handleClick}
      onMouseDown={() => setPressing(true)}
      onMouseUp={() => setPressing(false)}
      onMouseLeave={() => setPressing(false)}
      onTouchStart={() => setPressing(true)}
      onTouchEnd={() => setPressing(false)}
    >
      <div className="toggle-button-track" />

      <div
        className={classNames("toggle-thumb", { "toggle-thumb-on": props.value, "toggle-thumb-off": !props.value })}
        style={{
          transform: `scaleX(${squishX}) scaleY(${squishY})`,
          left: `${left}px`
        }}
      >
        <div className={classNames("toggle-thumb-icon", { "toggle-thumb-icon-on": props.value, "toggle-thumb-icon-off": !props.value })}>
          {props.value ? <PhosphorCheck iconSize="small" /> : <PhosphorX iconSize="small" />}
        </div>
      </div>
    </button>
  );
}
